import React from 'react';
type FormFieldProps = {
  id: string;
  label: string;
  error?: string;
  hint?: string;
  children: React.ReactElement;
};
export const inputClasses = 'w-full rounded-md border border-titanium/20 bg-graphite px-4 py-3 text-white placeholder:text-titanium/40 transition-[border-color] duration-150 focus:border-marine focus:outline-none aria-[invalid=true]:border-red-400';
export function FormField({
  id,
  label,
  error,
  hint,
  children
}: FormFieldProps) {
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;
  return <div data-id="element-992" data-mp="iy6nusupcyr8">
      <label htmlFor={id} className="block text-sm font-medium text-white" data-id="element-993" data-mp="ixwwb0u0ejjf">
        {label}
      </label>
      <div className="mt-2" data-id="element-994" data-mp="923cqxhvhps5">
        {React.cloneElement(children, {
        id,
        'aria-invalid': Boolean(error),
        'aria-describedby': describedBy
      })}
      </div>
      {error ? <p id={`${id}-error`} className="mt-1.5 text-sm text-red-300" data-id="element-995" data-mp="2orwm16u8dc36">
          {error}
        </p> : hint ? <p id={`${id}-hint`} className="mt-1.5 text-xs text-titanium/70" data-id="element-996" data-mp="2tpy5hsvkjdf6">
          {hint}
        </p> : null}
    </div>;
}